import { ProportionalSaleTypes } from './types';

interface ProportionalSaleProps {
  payment_form: number;
  services_ids: Array<number>;
}

export const ProportionalSaleSimulation = ({
  payment_form,
  services_ids,
}: ProportionalSaleProps) => ({
  types: [
    ProportionalSaleTypes.GET_PROPORTIONAL_SALE_REQUEST,
    ProportionalSaleTypes.GET_PROPORTIONAL_SALE_SUCCESS,
    ProportionalSaleTypes.GET_PROPORTIONAL_SALE_FAILURE,
  ],
  payment_form,
  services_ids,
  promise: (client: any) =>
    client.get('/api/controle_crm/proportional_sale_simulation', {
      params: { payment_form, services_ids },
    }),
});

export const SimulateRegister = () => ({
  types: [
    ProportionalSaleTypes.GET_SIMULATE_REGISTER_REQUEST,
    ProportionalSaleTypes.GET_SIMULATE_REGISTER_SUCCESS,
    ProportionalSaleTypes.GET_SIMULATE_REGISTER_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/api/controle_crm/return_package_by_plan', {
      params: { beginner: true },
    }),
});

export const SimulateWasSubscriber = () => ({
  types: [
    ProportionalSaleTypes.GET_SIMULATE_WAS_SUBSCRIBER_REQUEST,
    ProportionalSaleTypes.GET_SIMULATE_WAS_SUBSCRIBER_SUCCESS,
    ProportionalSaleTypes.GET_SIMULATE_WAS_SUBSCRIBER_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/api/controle_crm/return_package_by_plan', {
      params: { was_subscriber: true },
    }),
});

export const SimulatePlan = (params: {
  beginner?: boolean;
  was_subscriber?: boolean;
  black_friday?: boolean;
}) => ({
  types: [
    ProportionalSaleTypes.CAMPAIGN_SIMULATION_REQUEST,
    ProportionalSaleTypes.CAMPAIGN_SIMULATION_SUCCESS,
    ProportionalSaleTypes.CAMPAIGN_SIMULATION_FAILURE,
  ],
  promise: (client: any) =>
    client.get('/api/controle_crm/return_package_by_plan', {
      params,
    }),
});
